module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pdf-content container-fluid",
    attrs: {
      "id": "pdf"
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "row"
    }
  }, [_c('img', {
    staticClass: "logo_leak logo",
    attrs: {
      "width": "200px",
      "src": _vm.logoUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Evento #" + _vm._s(_vm.event && _vm.event.id))]), _vm._v(" "), _c('div', {
    staticClass: "pdf__info"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" De: ")]), _vm._v(" " + _vm._s(_vm.fromCompany) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Fecha: ")]), _vm._v(" " + _vm._s(_vm.event && _vm.event.fecha) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Ducto: ")]), _vm._v(" " + _vm._s(_vm.event && _vm.event.ducto) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Tramo: ")]), _vm._v(" " + _vm._s(_vm.event && _vm.event.tramo) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Ubicación del evento ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "90%"
    }
  }, [(_vm.mapImg) ? _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%",
      "margin": "auto"
    },
    attrs: {
      "id": "img_map",
      "src": ("" + _vm.mapImg)
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "max-width": "100%",
      "height": "25vh",
      "padding": "0px",
      "margin": "0px",
      "border-width": "0px",
      "cursor": "default"
    }
  }, _vm._l((_vm.chartCanvas), function(canvas) {
    return _c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "100%",
        "position": "absolute",
        "left": "0px",
        "top": "0px",
        "width": "1554px",
        "height": "395px",
        "user-select": "none",
        "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)",
        "padding": "0px",
        "margin": "0px",
        "border-width": "0px"
      },
      attrs: {
        "src": canvas.toDataURL()
      }
    })
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableholder"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.event) ? _c('tbody', [_c('tr', {
    attrs: {
      "id": "trw"
    }
  }, [_c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.fecha) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.km) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.lat) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.lng) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.tipo === 1 ? 'Apertura' : 'Cierre') + " ")])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Para: ")]), _vm._v(" A quien corresponda ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    attrs: {
      "id": "header"
    }
  }, [_c('tr', {
    attrs: {
      "id": "trh"
    }
  }, [_c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Fecha Evento")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Kilometro")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Latitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Longitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Acción")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8a8e030","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Historico/PdfView.vue
// module id = 1711
// module chunks = 6